import { render, staticRenderFns } from "./CreativeStatsTableV2.vue?vue&type=template&id=3b58472d&"
import script from "./CreativeStatsTableV2.vue?vue&type=script&lang=js&"
export * from "./CreativeStatsTableV2.vue?vue&type=script&lang=js&"
import style0 from "./CreativeStatsTableV2.vue?vue&type=style&index=0&id=3b58472d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports